module.exports = __webpack_public_path__ + "media/images/edit-4b3aff1fe378363d6ff660b3e3225bd5.svg";